import { Box, Typography } from '@mui/material'

interface PublicPageIntroProps {
  title: string
  description: string
}

export const PublicPageIntro = ({ title, description }: PublicPageIntroProps) => {
  return (
    <Box
      sx={{
        mb: 4,
        p: { xs: 3, md: 4 },
        borderRadius: 3,
        color: 'common.white',
        background: 'linear-gradient(135deg, #0d2a63 0%, #1f4aa8 100%)',
      }}
    >
      <Typography variant="h3" component="h1" gutterBottom sx={{ color: 'common.white' }}>
        {title}
      </Typography>
      <Typography variant="h6" sx={{ color: 'grey.200', maxWidth: 680, fontWeight: 400 }}>
        {description}
      </Typography>
    </Box>
  )
}
